var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"RkmModal",staticClass:"rkm-modal",attrs:{"buttons":['cancel', 'save'],"large":"","title":"Alergias / Reações adversas"},on:{"save":_vm.handleSave}},[_c('Form',{ref:"Form",attrs:{"data":_vm.data,"index":_vm.index},on:{"save":function($event){return _vm.close()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }